document.addEventListener("DOMContentLoaded", function () {
  const volverButton = document.querySelector("#block-volver button");

  if (volverButton) {
    volverButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Encuentra el elemento activo en la miga de pan
      const activeItem = document.querySelector(".breadcrumb-item.active");

      if (activeItem) {
        // Encuentra el elemento anterior al activo
        const prevItem = activeItem.previousElementSibling;

        if (prevItem && prevItem.classList.contains("breadcrumb-item")) {
          // Obtiene el enlace del elemento anterior y navega a él
          const prevLink = prevItem.querySelector("a");
          if (prevLink && prevLink.href) {
            window.location.href = prevLink.href;
          }
        } else {
          console.error("No se encontró un elemento anterior en la miga de pan");
        }
      } else {
        console.error("No se encontró un elemento activo en la miga de pan");
      }
    });
  } else {
    // console.log("No se encontró el botón Volver");
  }
});
